import styled from 'styled-components';
import colors from '../../constants/color';
import materialUI from '../../material-UI';

export const ContainerModal = styled(materialUI.DialogContent)`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 300px;
`;

export const DialogHeader = styled(materialUI.DialogTitle)``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 40px;
`;
export const TitleHeader = styled.div`
  font-size: 1.10rem;
  color: ${colors.black};
  margin-left: 10px;
  font-family: Inter;
`;
export const Footer = styled(materialUI.DialogActions)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  height: 64px;
  border-top: 0.5px solid #C4C4C4;
`;
export const ButtonClose = styled.button`
  height: 36px;
  border: 1px solid ${colors.greenButton};
  border-radius: 30px;
  width: 100px;
  margin-left: 10px;
  color: ${colors.greenButton};
  cursor: pointer;
  background-color: white;
`;
export const ButtonSave = styled.button`
  height: 36px;
  cursor: pointer;
  border-radius: 30px;
  width: 100px;
  margin-right: 16px;
  color: ${colors.white};
  background-color: ${colors.greenButton};

  :hover {
    background-color: #54C181;
  }
`;
export const Modal = styled(materialUI.Dialog)``;
export const Divider = styled(materialUI.Divider)``;
export const IconButton = styled(materialUI.IconButton)`
  cursor: pointer;
`;
export const CircularProgress = styled(materialUI.CircularProgress)`
  margin-top: 2px;
`;
